import Player from './WistiaPlayer';
import Wrapper from './WistiaPlayerWrapper';

export const WistiaPlayer = Player;
export const WistiaPlayerWrapper = Wrapper;


// WEBPACK FOOTER //
// ./src/index.js